import { render } from "./QuestionDetailPage.vue?vue&type=template&id=0e8ae74c&scoped=true"
import script from "./QuestionDetailPage.vue?vue&type=script&lang=js"
export * from "./QuestionDetailPage.vue?vue&type=script&lang=js"

import "./QuestionDetailPage.vue?vue&type=style&index=0&id=0e8ae74c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8ae74c"]])

export default __exports__